import { Card, Col, Row } from 'react-bootstrap';

import { AddNewProfileForm } from '@components/Profile/AddNewProfile/AddNewProfileForm';
import { AddNewProfileInfo } from '@components/Profile/AddNewProfile/AddNewProfileInfo';

export const AddNewProfile = () => (
  <>
    <Card className="mb-2">
      <Card.Header className="bg-didxl text-white">
        Add new end-user profile
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <AddNewProfileForm />
          </Col>
        </Row>
      </Card.Body>
    </Card>
    <Card>
      <Card.Header className="bg-didxl text-white" />
      <Card.Body>
        <AddNewProfileInfo />
      </Card.Body>
    </Card>
  </>
);
